/* import __COLOCATED_TEMPLATE__ from './chip.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

/**
 * @typedef {object} Sizes
 * @property {string} [REGULAR] - Has minimum height
 * @property {string} [SMALL] - No minimum height
 */

/**
 * @typedef {object} Themes
 * @property {string} [BLACK] - For light palette
 * @property {string} [WHITE] - For dark palette
 * @property {string} [NONE] - No color declarations
 */

/**
 * @typedef {object} Variants
 * @property {string} [PRIMARY] - Outlined chip
 * @property {string} [SECONDARY] - Outlined chip with bold text
 */

/** @type {Sizes} */
const SIZES = {
  REGULAR: 'regular',
  SMALL: 'small',
};

/** @type {Themes} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
  NONE: 'none',
};

/**
 * @type {Variants}
 */
const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

/** @type {string} */
const CLASS_NAME = 'GLM-chip';
const CLASS_NAME_VERIFIED = `${CLASS_NAME}--verified`;

const SIZE_TO_CLASS_MAP = Object.keys(SIZES).reduce((accum, sizeKey) => {
  const size = SIZES[sizeKey];
  accum[size] = `${CLASS_NAME}--size-${size}`;
  return accum;
}, {});

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

const VARIANT_TO_CLASS_MAP = Object.keys(VARIANTS).reduce((accum, variantKey) => {
  const variant = VARIANTS[variantKey];
  accum[variant] = `${CLASS_NAME}--variant-${variant}`;
  return accum;
}, {});

/** @class */
class GlmChip extends Component {
  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
      this.args.verified && CLASS_NAME_VERIFIED,
      SIZE_TO_CLASS_MAP[this.args.size || SIZES.REGULAR],
      THEME_TO_CLASS_MAP[this.args.theme || THEMES.BLACK],
      VARIANT_TO_CLASS_MAP[this.args.variant || VARIANTS.PRIMARY],
    );
  }

  get className() {
    return CLASS_NAME;
  }
}

export default GlmChip;
